import script from "./DeskView.vue?vue&type=script&setup=true&lang=js"
export * from "./DeskView.vue?vue&type=script&setup=true&lang=js"

import "./DeskView.vue?vue&type=style&index=0&id=82a56268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a56268"]])

export default __exports__